<template>
    <div id="extra-ninetees">
        <img src="../assets/under-construction.gif" alt="Don't read this shit" />
        <img src="../assets/under-construction.gif" alt="Don't read this shit" />
    </div>
</template>

<script>
export default {
    name: "ExtraNinetees"    
}
</script>

<style lang="scss" scoped>
    #extra-ninetees {
        display: flex;
        justify-content: space-between;
    }
</style>
